import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_489a390e from 'nuxt_plugin_plugin_489a390e' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_43e764e8 from 'nuxt_plugin_sentryserver_43e764e8' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_43a41940 from 'nuxt_plugin_sentryclient_43a41940' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_ocbridgegoogletagmanagerb6a65b12_b5deeef2 from 'nuxt_plugin_ocbridgegoogletagmanagerb6a65b12_b5deeef2' // Source: ./oc-bridge.google-tag-manager.b6a65b12.js (mode: 'all')
import nuxt_plugin_ocbridgesegment9366ff04_6de0480f from 'nuxt_plugin_ocbridgesegment9366ff04_6de0480f' // Source: ./oc-bridge.segment.9366ff04.js (mode: 'all')
import nuxt_plugin_ocbridgebootstrap3e9884e3_ca989d26 from 'nuxt_plugin_ocbridgebootstrap3e9884e3_ca989d26' // Source: ./oc-bridge.bootstrap.3e9884e3.js (mode: 'all')
import nuxt_plugin_pluginutils_662e5197 from 'nuxt_plugin_pluginutils_662e5197' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_49e0d522 from 'nuxt_plugin_pluginrouting_49e0d522' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_5f5a0ce6 from 'nuxt_plugin_pluginmain_5f5a0ce6' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_apollomodule_6db870f0 from 'nuxt_plugin_apollomodule_6db870f0' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_axios_6eef0924 from 'nuxt_plugin_axios_6eef0924' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_nuxtClientInitclient_437b88b2 from 'nuxt_plugin_nuxtClientInitclient_437b88b2' // Source: ../plugins/nuxtClientInit.client.js (mode: 'client')
import nuxt_plugin_VueObserveVisibility_5cb5e839 from 'nuxt_plugin_VueObserveVisibility_5cb5e839' // Source: ../plugins/VueObserveVisibility.js (mode: 'all')
import nuxt_plugin_Vue2TouchEvents_51677a61 from 'nuxt_plugin_Vue2TouchEvents_51677a61' // Source: ../plugins/Vue2TouchEvents.js (mode: 'all')
import nuxt_plugin_vClickOutside_3a1129fa from 'nuxt_plugin_vClickOutside_3a1129fa' // Source: ../plugins/vClickOutside.js (mode: 'all')
import nuxt_plugin_vuelidate_4be431c8 from 'nuxt_plugin_vuelidate_4be431c8' // Source: ../plugins/vuelidate.js (mode: 'all')
import nuxt_plugin_url_33d515c4 from 'nuxt_plugin_url_33d515c4' // Source: ../plugins/url.js (mode: 'all')
import nuxt_plugin_globalComponents_61ab9908 from 'nuxt_plugin_globalComponents_61ab9908' // Source: ../plugins/globalComponents.js (mode: 'all')
import nuxt_plugin_VueProgressBar_54dba83e from 'nuxt_plugin_VueProgressBar_54dba83e' // Source: ../plugins/VueProgressBar.js (mode: 'all')
import nuxt_plugin_vueportal_5154face from 'nuxt_plugin_vueportal_5154face' // Source: ../plugins/vue-portal.js (mode: 'all')
import nuxt_plugin_helpers_1c816d70 from 'nuxt_plugin_helpers_1c816d70' // Source: ../plugins/helpers.js (mode: 'all')
import nuxt_plugin_breakpoint_08bc58b0 from 'nuxt_plugin_breakpoint_08bc58b0' // Source: ../plugins/breakpoint.js (mode: 'all')
import nuxt_plugin_navigationhistory_29e97486 from 'nuxt_plugin_navigationhistory_29e97486' // Source: ../plugins/navigation-history.js (mode: 'all')
import nuxt_plugin_router_79dc5b58 from 'nuxt_plugin_router_79dc5b58' // Source: ../plugins/router.js (mode: 'all')
import nuxt_plugin_page_922d665c from 'nuxt_plugin_page_922d665c' // Source: ../plugins/page.js (mode: 'all')
import nuxt_plugin_i18nclient_4461791c from 'nuxt_plugin_i18nclient_4461791c' // Source: ../plugins/i18n.client.js (mode: 'client')
import nuxt_plugin_dayjs_66ce5f68 from 'nuxt_plugin_dayjs_66ce5f68' // Source: ../plugins/dayjs.js (mode: 'all')
import nuxt_plugin_signupredirect_a7132548 from 'nuxt_plugin_signupredirect_a7132548' // Source: ../plugins/signup-redirect.js (mode: 'all')
import nuxt_plugin_modalclient_59a0dbd6 from 'nuxt_plugin_modalclient_59a0dbd6' // Source: ../plugins/modal.client.js (mode: 'client')
import nuxt_plugin_messages_e5c23816 from 'nuxt_plugin_messages_e5c23816' // Source: ../plugins/messages.js (mode: 'all')
import nuxt_plugin_impression_cf8a98d0 from 'nuxt_plugin_impression_cf8a98d0' // Source: ../plugins/impression.js (mode: 'all')
import nuxt_plugin_masonryWall_7b4fba44 from 'nuxt_plugin_masonryWall_7b4fba44' // Source: ../plugins/masonryWall.js (mode: 'all')
import nuxt_plugin_vuefinalmodal_4feb7bbe from 'nuxt_plugin_vuefinalmodal_4feb7bbe' // Source: ../plugins/vue-final-modal.js (mode: 'all')
import nuxt_plugin_echo_7481157c from 'nuxt_plugin_echo_7481157c' // Source: ../plugins/echo.js (mode: 'all')
import nuxt_plugin_FloatingVue_c2b59926 from 'nuxt_plugin_FloatingVue_c2b59926' // Source: ../plugins/FloatingVue.js (mode: 'all')
import nuxt_plugin_swiper_68e7f06e from 'nuxt_plugin_swiper_68e7f06e' // Source: ../plugins/swiper.js (mode: 'all')
import nuxt_plugin_segmentreferrer_2c81b2b0 from 'nuxt_plugin_segmentreferrer_2c81b2b0' // Source: ../plugins/segment-referrer.js (mode: 'all')
import nuxt_plugin_signupmodalhandler_abf43d28 from 'nuxt_plugin_signupmodalhandler_abf43d28' // Source: ../plugins/signup-modal-handler.js (mode: 'all')
import nuxt_plugin_datetime_5e0100f1 from 'nuxt_plugin_datetime_5e0100f1' // Source: ../plugins/datetime (mode: 'all')
import nuxt_plugin_notificationsclient_f727f91e from 'nuxt_plugin_notificationsclient_f727f91e' // Source: ../plugins/notifications-client.js (mode: 'all')
import nuxt_plugin_absoluteUrl_90883916 from 'nuxt_plugin_absoluteUrl_90883916' // Source: ../plugins/absoluteUrl.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: function() {
    const i18nHead = this.$nuxtI18nHead ?
    this.$nuxtI18nHead({ addSeoAttributes: true }) :
    { htmlAttrs: [], meta: [], link: [] };

    const config = process.client ? this.$config : this.publicRuntimeConfig;

    return {
      title: 'Orderchamp',
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      bodyAttrs: {
        class: 'text-black'
      },
      meta: [
      { charset: 'utf-8' },
      {
        name: 'viewport',
        content:
        'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0, minimal-ui'
      },
      { name: 'format-detection', content: 'telephone=no' },

      // Open Graph defaults
      { property: 'og:site_name', content: 'Orderchamp' },
      { property: 'og:type', content: 'website' },

      ...(['staging'].includes(config?.appEnv) ?
      [{ name: 'robots', content: 'noindex, nofollow' }] :
      [{}]),

      ...i18nHead.meta],

      link: [
      { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' },
      {
        rel: 'stylesheet',
        href: 'https://use.typekit.net/iiw6hgv.css',
        media: 'print',
        onload: "this.media='all'"
      },

      // Preconnects for faster loading
      { rel: 'preconnect', href: config.cdnUrl },
      { rel: 'preconnect', href: 'https://orderchampdev.prismic.io' },
      { rel: 'preconnect', href: 'https://images.prismic.io' },
      { rel: 'preconnect', href: 'https://use.typekit.net' },
      { rel: 'preconnect', href: 'https://p.typekit.net' },
      { rel: 'preconnect', href: 'https://stats.pusher.com' },
      { rel: 'preconnect', href: 'https://cdn.segment.com' },

      // Decode %2F back to / in i18n hreflang hrefs — Vue Router encodes
      // slashes in catch-all route params (e.g. /listings/:categoryPath*)
      ...i18nHead.link.map((l) =>
      l.href ? { ...l, href: l.href.replace(/%2F/gi, '/') } : l
      )]
    };
  },

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_489a390e === 'function') {
    await nuxt_plugin_plugin_489a390e(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_43e764e8 === 'function') {
    await nuxt_plugin_sentryserver_43e764e8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_43a41940 === 'function') {
    await nuxt_plugin_sentryclient_43a41940(app.context, inject)
  }

  if (typeof nuxt_plugin_ocbridgegoogletagmanagerb6a65b12_b5deeef2 === 'function') {
    await nuxt_plugin_ocbridgegoogletagmanagerb6a65b12_b5deeef2(app.context, inject)
  }

  if (typeof nuxt_plugin_ocbridgesegment9366ff04_6de0480f === 'function') {
    await nuxt_plugin_ocbridgesegment9366ff04_6de0480f(app.context, inject)
  }

  if (typeof nuxt_plugin_ocbridgebootstrap3e9884e3_ca989d26 === 'function') {
    await nuxt_plugin_ocbridgebootstrap3e9884e3_ca989d26(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_662e5197 === 'function') {
    await nuxt_plugin_pluginutils_662e5197(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_49e0d522 === 'function') {
    await nuxt_plugin_pluginrouting_49e0d522(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_5f5a0ce6 === 'function') {
    await nuxt_plugin_pluginmain_5f5a0ce6(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_6db870f0 === 'function') {
    await nuxt_plugin_apollomodule_6db870f0(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_6eef0924 === 'function') {
    await nuxt_plugin_axios_6eef0924(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtClientInitclient_437b88b2 === 'function') {
    await nuxt_plugin_nuxtClientInitclient_437b88b2(app.context, inject)
  }

  if (typeof nuxt_plugin_VueObserveVisibility_5cb5e839 === 'function') {
    await nuxt_plugin_VueObserveVisibility_5cb5e839(app.context, inject)
  }

  if (typeof nuxt_plugin_Vue2TouchEvents_51677a61 === 'function') {
    await nuxt_plugin_Vue2TouchEvents_51677a61(app.context, inject)
  }

  if (typeof nuxt_plugin_vClickOutside_3a1129fa === 'function') {
    await nuxt_plugin_vClickOutside_3a1129fa(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4be431c8 === 'function') {
    await nuxt_plugin_vuelidate_4be431c8(app.context, inject)
  }

  if (typeof nuxt_plugin_url_33d515c4 === 'function') {
    await nuxt_plugin_url_33d515c4(app.context, inject)
  }

  if (typeof nuxt_plugin_globalComponents_61ab9908 === 'function') {
    await nuxt_plugin_globalComponents_61ab9908(app.context, inject)
  }

  if (typeof nuxt_plugin_VueProgressBar_54dba83e === 'function') {
    await nuxt_plugin_VueProgressBar_54dba83e(app.context, inject)
  }

  if (typeof nuxt_plugin_vueportal_5154face === 'function') {
    await nuxt_plugin_vueportal_5154face(app.context, inject)
  }

  if (typeof nuxt_plugin_helpers_1c816d70 === 'function') {
    await nuxt_plugin_helpers_1c816d70(app.context, inject)
  }

  if (typeof nuxt_plugin_breakpoint_08bc58b0 === 'function') {
    await nuxt_plugin_breakpoint_08bc58b0(app.context, inject)
  }

  if (typeof nuxt_plugin_navigationhistory_29e97486 === 'function') {
    await nuxt_plugin_navigationhistory_29e97486(app.context, inject)
  }

  if (typeof nuxt_plugin_router_79dc5b58 === 'function') {
    await nuxt_plugin_router_79dc5b58(app.context, inject)
  }

  if (typeof nuxt_plugin_page_922d665c === 'function') {
    await nuxt_plugin_page_922d665c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_i18nclient_4461791c === 'function') {
    await nuxt_plugin_i18nclient_4461791c(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjs_66ce5f68 === 'function') {
    await nuxt_plugin_dayjs_66ce5f68(app.context, inject)
  }

  if (typeof nuxt_plugin_signupredirect_a7132548 === 'function') {
    await nuxt_plugin_signupredirect_a7132548(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_modalclient_59a0dbd6 === 'function') {
    await nuxt_plugin_modalclient_59a0dbd6(app.context, inject)
  }

  if (typeof nuxt_plugin_messages_e5c23816 === 'function') {
    await nuxt_plugin_messages_e5c23816(app.context, inject)
  }

  if (typeof nuxt_plugin_impression_cf8a98d0 === 'function') {
    await nuxt_plugin_impression_cf8a98d0(app.context, inject)
  }

  if (typeof nuxt_plugin_masonryWall_7b4fba44 === 'function') {
    await nuxt_plugin_masonryWall_7b4fba44(app.context, inject)
  }

  if (typeof nuxt_plugin_vuefinalmodal_4feb7bbe === 'function') {
    await nuxt_plugin_vuefinalmodal_4feb7bbe(app.context, inject)
  }

  if (typeof nuxt_plugin_echo_7481157c === 'function') {
    await nuxt_plugin_echo_7481157c(app.context, inject)
  }

  if (typeof nuxt_plugin_FloatingVue_c2b59926 === 'function') {
    await nuxt_plugin_FloatingVue_c2b59926(app.context, inject)
  }

  if (typeof nuxt_plugin_swiper_68e7f06e === 'function') {
    await nuxt_plugin_swiper_68e7f06e(app.context, inject)
  }

  if (typeof nuxt_plugin_segmentreferrer_2c81b2b0 === 'function') {
    await nuxt_plugin_segmentreferrer_2c81b2b0(app.context, inject)
  }

  if (typeof nuxt_plugin_signupmodalhandler_abf43d28 === 'function') {
    await nuxt_plugin_signupmodalhandler_abf43d28(app.context, inject)
  }

  if (typeof nuxt_plugin_datetime_5e0100f1 === 'function') {
    await nuxt_plugin_datetime_5e0100f1(app.context, inject)
  }

  if (typeof nuxt_plugin_notificationsclient_f727f91e === 'function') {
    await nuxt_plugin_notificationsclient_f727f91e(app.context, inject)
  }

  if (typeof nuxt_plugin_absoluteUrl_90883916 === 'function') {
    await nuxt_plugin_absoluteUrl_90883916(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
